import { useTranslation } from 'react-i18next';
import { AnimatedSection } from '../../../components/AnimatedSection';

export default function Values() {
  const { t } = useTranslation();

  const values = [
    { icon: 'ri-shield-check-line', title: t('about_v1_title'), description: t('about_v1_desc') },
    { icon: 'ri-medal-line', title: t('about_v2_title'), description: t('about_v2_desc') },
    { icon: 'ri-eye-line', title: t('about_v3_title'), description: t('about_v3_desc') },
    { icon: 'ri-focus-3-line', title: t('about_v4_title'), description: t('about_v4_desc') },
    { icon: 'ri-customer-service-2-line', title: t('about_v5_title'), description: t('about_v5_desc') },
    { icon: 'ri-refresh-line', title: t('about_v6_title'), description: t('about_v6_desc') },
  ];

  return (
    <section className="py-20 bg-slate-950">
      <div className="max-w-7xl mx-auto px-6">
        <AnimatedSection animation="fade-in" className="text-center mb-14">
          <span className="text-cyan-400 text-sm font-semibold tracking-widest uppercase">{t('about_values_badge')}</span>
          <h2 className="text-4xl font-bold text-white mt-3 mb-3">{t('about_values_title')}</h2>
          <p className="text-slate-400 max-w-xl mx-auto">{t('about_values_desc')}</p>
        </AnimatedSection>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {values.map((v, i) => (
            <AnimatedSection key={v.title} animation="fade-in" delay={i * 0.08}>
              <div className="bg-slate-800/50 border border-slate-700 hover:border-cyan-500/30 rounded-2xl p-7 transition-all">
                <div className="w-12 h-12 flex items-center justify-center bg-cyan-500/10 rounded-xl mb-5">
                  <i className={`${v.icon} text-cyan-400 text-xl`}></i>
                </div>
                <h3 className="text-white font-bold mb-2">{v.title}</h3>
                <p className="text-slate-400 text-sm leading-relaxed">{v.description}</p>
              </div>
            </AnimatedSection>
          ))}
        </div>
      </div>
    </section>
  );
}
